import { MeetingTranscript } from 'api/meeting/types';
import { Transcript, TranscriptSegment } from './types';

export const apiTranscriptToUiTranscript = (
  apiTranscript: MeetingTranscript,
): Transcript => {
  return {
    segments: apiTranscript.segments.reduce((acc, segment) => {
      const chunksAsSegments = segment.chunks.map((chunk) => ({
        startTime: parseFloat(chunk.start),
        endTime: parseFloat(chunk.end),
        speaker: segment.speaker,
        text: chunk.text,
      }));

      return acc.concat(chunksAsSegments);
    }, [] as TranscriptSegment[]),
  };
};
